<template lang="pug">
BlueSearch(@presearch="handlePresearch")
  template(#default="{reloading}")
    .search__layout
      SearchQuery
        template(#default="{executeSearch, extend, extended, clearPreviousItemResults}")
          Query(
            :executeSearch="executeSearch",
            :extend="extend",
            :extended="extended",
            :clearPreviousItemResults="clearPreviousItemResults"
          )
      SearchResults
        template(#default="resultsProps")
          Results
      SearchPagination
        template(#default="paginationProps")
          Pagination
</template> 

<script>
import Query from "./components/query/Query.vue";
import Results from "./components/results/Results.vue"
import Pagination from "./components/pagination/Pagination.vue"
export default {
  name: "VitalantDocumentFormListing",
  components: {
		Query,
    Results,
    Pagination
  },
  data() {
      return {
        params: null
      }
  },
  methods: {
    handlePresearch({done, extend, extended}) {
      // Grab url data and create presearch object
      //const url = new URL(document.URL)
      //const params = new URLSearchParams(url.search)

      // odd condition to check if urlsearchparams actually has anything
      // It works so good enough?
      //
      
        extended.presearch = {}
      
        extend(extended => {
          // add presearch data if url query contains it
          if(this.params.has('category')) extended.presearch.category = this.params.get('category')
          if(this.params.has('service')) extended.presearch.service = this.params.get('service')
          if(this.params.has('state')) extended.presearch.state = this.params.get('state')
          return extended
        })
      
      done()
    }
  },
  created () {
    this.params = new URLSearchParams(window.location.search)
  }
};
</script>

<style lang="scss">
// All possible CSS variable overrides
#bluesearch {
  --font-size: 1rem/* property value */;
  --font-weight: 300/* property value */;
  --font-family: #{$fontFamilyBase}/* property value */;
  --line-height: .8rem/* property value */;
  --color: #{$fontColorBase}/* property value */;

  --link-color: #{$linkColor}/* property value */;
  --link-hover-color: #{$linkColorHover}/* property value */;
  --link-transition: all .25s ease-in-out/* property value */;

  --loader-color: #{$primaryPurple}/* property value */;

  --accordion-title-color: /* property value */;
  --accordion-title-active-color: /* property value */;
  --accordion-title-transition: all .25s ease-in-out/* property value */;

  --border-color: #{$gray}/* property value */;

  --label-color: #{$gray}/* property value */;
  --label-background: /* property value */;

  --button-color: #{$buttonPrimaryColor} /* property value */;
  --button-background: #{$buttonPrimaryBackground}/* property value */;
  --button-hover-color: #{$buttonPrimaryColorHover}/* property value */;
  --button-hover-background: #{$buttonPrimaryBackgroundHover} /* property value */;
  --button-transition: all .25s ease-in-out/* property value */;

  --check-background: /* property value */;
  --check-border: /* property value */;
  --check-active-color: /* property value */;
  --check-active-background: /* property value */;
  --check-active-border: /* property value */;
  --check-transition: all .25s ease-in-out/* property value */;

  --tag-color: /* property value */;
  --tag-background: /* property value */;
  --tag-hover-color: /* property value */;
  --tag-hover-background: /* property value */;
  --tag-transition: all .25s ease-in-out/* property value */;

  --pagination-nav-color: /* property value */;
  --pagination-nav-background:#{buttonPrimaryBackground} /* property value */;
  --pagination-nav-hover-color: #{$buttonPrimaryColorHover}/* property value */;
  --pagination-nav-hover-background:#{$buttonPrimaryColorHover} /* property value */;
  --pagination-nav-disabled-opacity: /* property value */;
  --pagination-nav-transition: all .25s ease-in-out/* property value */;

  --pagination-number-color: #{$lightGray}/* property value */;
  --pagination-number-background: #{$buttonPrimaryColor}/* property value */;
  --pagination-number-hover-color: ##{$buttonPrimaryColorHover} /* property value */;
  --pagination-number-hover-background: /* property value */;
  --pagination-number-active-color: #{$gray}/* property value */;
  --pagination-number-active-background: /* property value */;
  --pagination-number-transition: all .25s ease-in-out/* property value */;
  .search {
    &__layout {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    &__main {

    }
    &__results {

    }
    &__footer {

    }
  }
  .search-query {
    &__form {

    }
    &__wrapper {

    }
    &__input {
      
      &::placeholder{
      }
    }
    &__submit {

    }
    &__sort {

    }
    &__results {

    }
  }
  .search-result {
    &__img{
    }
    &__content {

    }
    &__title {

    }
    &__date {

    }
    &__summary {

    }
  }
  .search-pagination {
    justify-content: center;
    
    &__inner {

    }
    &__prev {

    }
    &__number {

    }
    &__next {

    }
  }
}
</style>